export default "__VITE_ASSET__Bclu8Kkw__"